query ActiveApprovalTypes($isAllPhases: Boolean, $phaseTypeId: Int) {
  activeApprovalTypes(orderBy: APPROVAL_TYPE_ASC, isAllPhases: $isAllPhases, phaseTypeId: $phaseTypeId) {
    nodes {
      id
      approvalType
      _activeCount
    }
  }
}